import axios from "axios";
import { handleUnauthorizedSession, shouldHandleUnauthorizedForUrl } from "./authSession";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(request => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  if (!request.headers['x-request-id']) {
    request.headers['x-request-id'] = typeof crypto?.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  return request;
}, error => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url;
    const responseError = error?.response?.data?.error;

    if (status === 401 && shouldHandleUnauthorizedForUrl(requestUrl, responseError)) {
      handleUnauthorizedSession();
    }

    return Promise.reject(error);
  }
);
